import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateField } from "services";

import { invalidateCarbonProgramQueriesByChunk } from "utils";

import { GET_FARM_REPORTING_YEAR, GET_FIELDS, GET_FIELD_SHAPE, GET_VERIFICATION_EDITING_REQUESTS, UPDATE_FIELD } from "consts";

export const useUpdateField = ({ farmId }: { farmId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_FIELD],
    mutationFn: updateField,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [GET_FIELDS] });
      queryClient.invalidateQueries({ queryKey: [GET_VERIFICATION_EDITING_REQUESTS, farmId] });
      invalidateCarbonProgramQueriesByChunk(variables.id);
      queryClient.invalidateQueries({ queryKey: [GET_FARM_REPORTING_YEAR, farmId] });
      queryClient.invalidateQueries({ queryKey: [GET_FIELD_SHAPE, variables.id] });
    },
  });
};
